import { AllowedAccess } from 'react-permission-role'

import Container from '@mui/material/Container'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Typography from '@mui/material/Typography'
// import { Button, CardBody, CardHeader, CardTitle } from 'reactstrap'

import { Button, Card, CardContent, Grid } from '@mui/material'
import { ArrowLeft, ArrowLeftCircle, ArrowRightCircle, Save } from 'react-feather'
import { FormStepApplication } from './StepApplication/FormStepApplication'
import { ObservationsVehicle } from './common/ObservationsManagement'
import { FormStepFiles } from './StepFiles/FormStepFiles'
import { FormStepDeposit } from './StepDeposit/FormStepDeposit'
import { FormStepPreInventory } from './StepPreInventory/FormStepPreInventory'
import { FormStepApproval } from './StepApproval/FormStepApproval'


// Array que define cuantos pasos va a tener
const steps = ['Info. de Venta', 'Documentos Adjuntos', 'Depositos', 'Pre-Inventario', 'Info. Aprobación']

const VehicleForm = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const { stepApplilication } = globalStates

    const { handleClickUpdateStatusAprobacion, handleClickReturnStep, handleClickHideForm, onSendLogs } = Actions

    const { FormRequestGlobal:{formState, onInputChange} } = Forms

    const {fetchInfoObservations:{observations}} = FetchData

    // Para definir que va a renderizar en cada paso
    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <FormStepApplication 
                    useFetchInit = {useFetchInit}
                />
            case 1:
                return <FormStepFiles 
                    useFetchInit = {useFetchInit}
                />;
            case 2: 
                return <FormStepDeposit
                    useFetchInit = {useFetchInit}
                />;
            case 3:
                return <FormStepPreInventory
                    useFetchInit = {useFetchInit}
                />;
            case 4:
                return <FormStepApproval
                    useFetchInit = {useFetchInit}
                />;
                
        }
    }

    return (
        <AllowedAccess permissions={['101_VEHICULOS_VENTAS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                <div className='panel-body'>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Card style={{zIndex:'1'}}>
                                <CardContent>
                                    <Button
                                        startIcon={<ArrowLeft/>}
                                        variant='contained'
                                        color='error'
                                        size='large'
                                        sx={{ marginTop: 2, marginBottom : 2 }}
                                        onClick={handleClickHideForm}
                                    ></Button>
                                    <Typography variant="h6" gutterBottom> Solicitud Vehiculos</Typography>
                                    <div className="border-bottom border-dark"></div>

                                    <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                                        <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                                            {steps.map((label) => (
                                                <Step key={label}>
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Container>
                                    
                                    <p className='text-danger'>* campos obligatorios</p>
                                    {stepApplilication === steps.length ? (
                                        <div className='text-center'>
                                        <Typography variant="h5" gutterBottom>
                                            Confirmación de procedimiento.
                                        </Typography>
                                        <p> 
                                            Todos los pasos se han cumplido, 
                                            haga click en el botón de "Finalizar procedimiento" para volver a la pantalla de solicitudes,
                                            o "Volver a revisar" para volver a al paso anterior
                                        </p>
                                        <div className="border-bottom border-secondary m-3"></div>
                                        <div className="text-center">
                                        <Button 
                                            startIcon={<ArrowLeftCircle/>}
                                            variant="contained"
                                            type="button" 
                                            className='btn-round'
                                            color='warning'
                                            onClick={handleClickReturnStep} 
                                            sx={{ marginRight: 1, marginLeft: 1 }}
                                        >
                                            Volver
                                        </Button>
                                        <Button
                                            endIcon={<Save/>}
                                            variant="contained"
                                            className='btn-round'
                                            color='primary'
                                            type='button'
                                            sx={{ marginRight: 1, marginLeft: 1 }}
                                            onClick={handleClickUpdateStatusAprobacion}
                                        >
                                            Finalizar procedimiento
                                        </Button>
                                        </div>
                                    </div>

                                ) : (
                                    <>
                                        {getStepContent(stepApplilication)}
                                        {(formState.idventa>0)&&(
                                            <ObservationsVehicle
                                            formState={formState}
                                            onInputChange={onInputChange}
                                            onSendLogs={onSendLogs}
                                            observations={observations}
                                            />    
                                        )}
                                    </>
                                )}

                                </CardContent>
                            </Card>
                        </Grid> 
                    </Grid> 
                </div>
            </div>
        </AllowedAccess>

    )
    
}

export {
    VehicleForm
}